var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreIconinline = function SvgMoreIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "aa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F075C7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A875",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.417 20.696H4.582a.625.625 0 000 1.25h20.835a.625.625 0 000-1.25zM23.128 24.5H6.87a.625.625 0 000 1.25h16.258a.625.625 0 100-1.25zm4.216-6.985c0 .345-.28.625-.625.625H3.28a.625.625 0 110-1.25h4.064c.086-4.148 3.487-7.496 7.655-7.496s7.57 3.348 7.656 7.496h4.063c.345 0 .625.28.625.625zM15 7.409c.345 0 .625-.28.625-.625v-3.16a.625.625 0 00-1.25 0v3.16c0 .345.28.625.625.625zm-7.702 2.824a.623.623 0 00.883 0 .625.625 0 000-.884L5.947 7.115A.625.625 0 105.063 8l2.235 2.234zm14.52 0a.625.625 0 010-.884l2.235-2.234a.625.625 0 11.884.884l-2.235 2.234a.623.623 0 01-.884 0z",
    id: "ab"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#aa)",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#ab",
    transform: "translate(18 18)"
  }))));
};
export default SvgMoreIconinline;